import React, { useState, useEffect, useRef } from 'react';
import './webstats.css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

import DatePicker from 'react-datepicker'; 
import 'react-datepicker/dist/react-datepicker.css';

//import logo from 'https://ucarecdn.com/ebf43df5-eac6-4844-8271-ddd87ae637a4/-/preview/500x500/-/quality/smart/-/format/auto/'; // Replace with your actual logo image URL

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);        
        
function Webstats() {

    const [localData,  setlocalData] = useState([]);
    const [visitData, setVisitData] = useState({});
    const [documentCount, setDocumentCount] = useState(0);
    const [graphcss, setGraphcss] = useState(false);

    const [addPopup, setaddPopup] = useState(false);
    const [addPopupmessage, setaddPopupmessage] = useState(false);

    const end = moment().subtract(31, 'days').startOf('day').toDate();


    const start = moment().endOf('day').toDate();

   
    
    const formattedStartDate = moment().subtract(31, 'days').format('DD MMMM YYYY');
    const formattedEndDate = moment().format('DD MMMM YYYY');
        
    const [wstatsDetails, setwstatsDetails] = useState({
        startDate: start,
        endDate: end,
        writeStartDate: formattedStartDate,
        writeEndDate: formattedEndDate,
        editcheck: "initial"
    });
    
    const [wstatsdayDetails, setwstatsdayDetails] = useState({
        startDate: "",
        endDate: "",
    });

    const [dbsearch, setdbsearch] = useState({
      startDate: "",
      endDate: "",
    });


    const loc = window.location;
    const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
    const dynamicgetwebstats = '/getwebstats';
    const getwebstatsurl = baseUrl + dynamicgetwebstats;


    useEffect(() => {
          
            //console.log("clicked option seeeeeeeeeeeeeent", location.state.data.quiznum )
            
              const fetchContents = async () => {
                //await dispatch(getOutlines(parsedObj));
                await fetch(getwebstatsurl,{
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ wstatsDetails })
                })
                  .then(response => response.json())
                  .then(data => {
                    //console.log("data contents fetched books db",data.startDate)
                    setlocalData(data.messdata);
                    setDocumentCount(data.messdata.length);
                    setdbsearch({...dbsearch, startDate: data.startDate, endDate: data.endDate})
          
                    //setContentData(data);
                    
                  
                });
                
              };
          
              fetchContents();
          
        }, []);


        useEffect(() => {
          const processVisitData = () => {



            // Get current date
            /*const currentDate = new Date();
            
            // Calculate date 31 days ago
            const startDate = new Date(currentDate);
            startDate.setDate(currentDate.getDate() - 31);*/
      
            // Initialize counts for all days in range
            const visitCounts = {};
            //const currentDate = dbsearch.endDate; 
            //console.log("currentdate is startdat", startDate)
            //console.log("currentdate is enddate", currentDate)
            // Fill in all dates in the range with 0
            const tempDate = new Date(dbsearch.startDate);
            const startDate = new Date(dbsearch.startDate);
            startDate.setHours(0, 0, 0, 0); 
            const currentDate = new Date(dbsearch.endDate);
            currentDate.setHours(23, 59, 59, 999); 
            while (tempDate <= currentDate) {
              const dateKey = tempDate.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit'
              });
              visitCounts[dateKey] = 0;
              tempDate.setDate(tempDate.getDate() + 1);
            }
      
            // Get data from localStorage - replace 'yourDataKey' with actual key
            /*const rawData = localStorage.getItem('yourDataKey');
            if (!rawData) return visitCounts;
            
            const documents = JSON.parse(rawData);*/
      
            // Process each document
            localData.forEach(doc => {
              doc.visithistory.forEach(visit => {
                const visitDate = new Date(visit.lastVisit);
                
                // Only count if date is within our range
                if (visitDate >= startDate && visitDate <= currentDate) {
                  const dateKey = visitDate.toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit'
                  });
                  visitCounts[dateKey] = (visitCounts[dateKey] || 0) + 1;
                }
              });
            });
      
            setVisitData(visitCounts);
          };
      
          processVisitData();
        }, [localData, dbsearch]);


        function handleAddSubmit(e) {
          e.preventDefault();
         setaddPopup(true);
         setaddPopupmessage('Searching')
          const Addquestion = async () => {
              //await dispatch(getOutlines(parsedObj));
              await fetch(getwebstatsurl, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({ wstatsdayDetails, wstatsDetails }),
              
              })
              .then(response => response.json())
                .then(data => {
                  if (data.message === "Successful"){
                      setlocalData(data.messdata);
                      setDocumentCount(data.messdata.length);
                      setdbsearch({...dbsearch, startDate: data.startDate, endDate: data.endDate})
                      setaddPopup(false);
                  }else{
                      setaddPopupmessage('Failed!!! please check network')
                  }
              });
  
              
              
              
          };
      
          Addquestion();
      }

        const handleDateChange = (date) => {
          //setSelectedDate(date);
          setwstatsdayDetails({...wstatsdayDetails, startDate: date})
          setwstatsDetails({...wstatsDetails, editcheck: "searching"})
          //console.log('number of moths', date)
        };

        const handlendDateChange = (date) => {
          setwstatsdayDetails({...wstatsdayDetails, endDate: date})
          setwstatsDetails({...wstatsDetails, editcheck: "searching"})
          //console.log('number of moths', date)
        }

        function closeaddpop () {
            setaddPopup(false);
            clear();
        };

        const clear = () => {

          setwstatsdayDetails({ ...wstatsdayDetails, 
              startDate: "",
              endDate: ""  
          });
        }


        const contentRef = useRef(null);
        const chartRef = useRef(null);
        const barchartRef = useRef(null);
         const [loading, setLoading] = useState(false);
    
         const generatePdf = async () => {
          if (!contentRef.current || !dbsearch?.startDate || !dbsearch?.endDate) return;
        
          setGraphcss(true);
          setLoading(true);
          
          try {
            const { default: jsPDF } = await import('jspdf');
            const { default: html2canvas } = await import('html2canvas');
            
            const content = contentRef.current;
            
            // Ensure charts are fully rendered before proceeding
            await new Promise(resolve => setTimeout(resolve, 2000));
        
            const a4Width = 793;
            const a4Height = 1122;
            
            // Get original charts and create base64 images before cloning
            const originalCharts = Array.from(content.querySelectorAll('canvas'));
            const chartImages = originalCharts.map(chart => chart.toDataURL('image/png'));
            
            // Create clone
            const clone = content.cloneNode(true);
            document.body.appendChild(clone);
            
            // Apply fixed styling
            clone.style.cssText = `
              width: ${a4Width}px !important;
              height: auto !important;
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              transform: none !important;
              transform-origin: top left !important;
              max-width: none !important;
              max-height: none !important;
              margin: 0 !important;
              padding: 20px !important;
              box-sizing: border-box !important;
              overflow: hidden !important;
              z-index: -9999 !important;
              background: white !important;
            `;
        
            // Replace cloned canvases with images
            const clonedCharts = Array.from(clone.querySelectorAll('canvas'));
            clonedCharts.forEach((clonedChart, index) => {
              const img = document.createElement('img');
              img.src = chartImages[index];
              img.style.width = '100%';
              img.style.height = 'auto';
              img.style.maxWidth = `${a4Width - 40}px`; // Account for padding
              clonedChart.parentNode.replaceChild(img, clonedChart);
            });
        
            // Calculate total height after fixing width
            const totalHeight = clone.scrollHeight;
            const pagesCount = Math.ceil(totalHeight / a4Height);
        
            const pdf = new jsPDF({
              orientation: 'portrait',
              unit: 'px',
              format: 'a4',
              compress: true
            });
        
            for (let pageIndex = 0; pageIndex < pagesCount; pageIndex++) {
              const yOffset = pageIndex * a4Height;
              const remainingHeight = totalHeight - yOffset;
              const pageHeight = Math.min(a4Height, remainingHeight);
        
              clone.style.top = `${-yOffset}px`;
        
              const canvas = await html2canvas(clone, {
                scale: 2,
                useCORS: true,
                logging: false,
                width: a4Width,
                height: pageHeight,
                windowWidth: a4Width,
                backgroundColor: '#ffffff',
                imageTimeout: 2000,
                removeContainer: false,
                willReadFrequently: true,
                quality: 1,
                y: yOffset
              });
        
              if (pageIndex > 0) {
                pdf.addPage();
              }
              
              const imgHeight = (pageHeight / a4Width) * pdf.internal.pageSize.getWidth();
              
              pdf.addImage(
                canvas.toDataURL('image/jpeg', 1.0),
                'JPEG',
                0,
                0,
                pdf.internal.pageSize.getWidth(),
                imgHeight,
                undefined,
                'FAST'
              );
            }
        
            // Clean up
            document.body.removeChild(clone);
            
            pdf.save(`website_report_${dbsearch.startDate}_to_${dbsearch.endDate}.pdf`);
            setGraphcss(false);
        
          } catch (error) {
            console.error('Failed to generate PDF:', error);
          } finally {
            setLoading(false);
          }
        };
        
  
   
    if (localData !== null) {

      const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Daily Visit Counts',
          },
          tooltip: {
            callbacks: {
              title: (context) => `Date: ${context[0].label}`,
              label: (context) => `visitors: ${context.raw}`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Number of Visitors'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Date'
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            }
          }
        }
      };

      const chartData = {
        // Sort dates chronologically
        labels: Object.keys(visitData).sort((a, b) => {
          const [aMonth, aDay] = a.split('/');
          const [bMonth, bDay] = b.split('/');
          return new Date(2024, aMonth - 1, aDay) - new Date(2024, bMonth - 1, bDay);
        }),
        datasets: [
          {
            label: 'Daily Visitor Trend',
            data: Object.keys(visitData).sort((a, b) => {
              const [aMonth, aDay] = a.split('/');
              const [bMonth, bDay] = b.split('/');
              return new Date(2024, aMonth - 1, aDay) - new Date(2024, bMonth - 1, bDay);
            }).map(date => visitData[date]),
            borderColor: 'rgb(75, 192, 192)',
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8,
          },
        ],
      };

      
        const startDate = new Date(dbsearch.startDate);
        startDate.setHours(0, 0, 0, 0); 
        const currentDate = new Date(dbsearch.endDate);
        currentDate.setHours(23, 59, 59, 999); 

        const startDatetopic = startDate.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit'
        });

        const currentDatetopic = currentDate.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit'
        });



      const totalVisits = localData.map(doc => {
        return doc.visithistory
          .filter(visit => {
            const visitDate = new Date(visit.lastVisit);
            return (visitDate >= startDate && visitDate <= currentDate);
          })
          .reduce((sum, visit) => sum + visit.totalVisits, 0);
      });
  
      // Sum up all document totals
      const grandTotal = totalVisits.reduce((sum, total) => sum + total, 0);

      const totalTime = localData.map(doc => {
        return doc.visithistory
          .filter(visit => {
            const visitDate = new Date(visit.lastVisit);
            return (visitDate >= startDate && visitDate <= currentDate);
          })
          .reduce((sum, visit) => sum + visit.totalTimeOnSite, 0);
      });
  
      // Sum up all document totals
      const grandTimeTotal = totalTime.reduce((sum, total) => sum + total, 0);

      const seconds = Math.floor(grandTimeTotal / 1000);
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      const averagetotaltime = grandTimeTotal/documentCount;

      const aveseconds = Math.floor(averagetotaltime / 1000);
      const avehours = Math.floor(aveseconds / 3600);
      const aveminutes = Math.floor((aveseconds % 3600) / 60);
      const averemainingSeconds = aveseconds % 60;

      /////////////////////////////////Bar Graph//////////////////////////////////////
        const allPages = localData.flatMap(doc => {
          // Parse the document content if it's a string
          const visitData = typeof doc.document_content === 'string' 
            ? JSON.parse(doc.document_content)
            : doc.document_content;
      
          // Extract paths from visithistory array
          return doc.visithistory.flatMap(visit =>
              (new Date(visit.lastVisit) >= startDate && new Date(visit.lastVisit) <= currentDate) ?
              visit.lastPages.map(page => page.path === "/" ? "landing" : page.path)
              :
              []
          );
        });
      
        // Count occurrences of each page
        const pageCounts = allPages.reduce((acc, path) => {
          acc[path] = (acc[path] || 0) + 1;
          return acc;
        }, {});
      
        // Convert to array and sort by count
        const sortedPages = Object.entries(pageCounts)
          .map(([path, count]) => ({ path, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 10);

          // Find the maximum count to set the scale
        const maxCount = Math.max(...sortedPages.map(page => page.count));
        // Calculate a nice round number slightly above the max for the scale
        const yAxisMax = Math.ceil(maxCount * 1.1);

        

          const optionbarm = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Top 10 Most Visited Pages Across Website',
                font: {
                  size: 16,
                  weight: 'bold'
                }
              },
              tooltip: {
                callbacks: {
                  label: (context) => `Visits: ${context.raw}`
                }
              }
            },
            scales: {
              x: {
                ticks: {
                  maxRotation: 45,
                  minRotation: 45
                }
              },
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of Visits'
                },
                ticks: {
                  precision: 0 // Show whole numbers only
                }
              }
            }
          };
          
          const optionbar = {
            animation: false,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Top 10 Most Visited Pages Across Website',
                font: {
                  size: 16,
                  weight: 'bold'
                }
              },
              tooltip: {
                callbacks: {
                  label: (context) => `Visits: ${context.raw}`
                }
              }
            },
            scales: {
              x: {
                grid: {
                  display: true,
                  drawBorder: true,
                  drawOnChartArea: true,
                  drawTicks: true,
                  color: 'rgba(0, 0, 0, 0.1)'
                },
                ticks: {
                  maxRotation: 45,
                  minRotation: 45
                }
              },
              y: {
                beginAtZero: true,
                grid: {
                  display: true,
                  drawBorder: true,
                  drawOnChartArea: true,
                  drawTicks: true,
                  color: 'rgba(0, 0, 0, 0.1)'
                },
                title: {
                  display: true,
                  text: 'Number of Visits'
                },
                ticks: {
                  precision: 0 // Show whole numbers only
                }
              }
            }
          };
        
          const databar = {
            labels: sortedPages.map(page => page.path.replace('/', '')), // Remove leading slash for cleaner labels
            datasets: [
              {
                label: 'Page Visits',
                data: sortedPages.map(page => page.count),
                backgroundColor: 'rgba(53, 162, 235, 0.6)',
                borderColor: 'rgba(53, 162, 235, 1)',
                borderWidth: 1,
              },
            ],
          };

    /////////////////////////////////Visitors Country////////////////////////////////
    const countryCounts = localData.reduce((acc, item) => {
      acc[item.country] = (acc[item.country] || 0) + 1;
      return acc;
    }, {});

    const sortedCountries = Object.keys(countryCounts).sort((a, b) => countryCounts[b] - countryCounts[a]);

    // Take the first 10 categories just changed categories
    const topCoutries = sortedCountries.slice(0, 10);

    const getcountriescard = topCoutries.map((post, index) =>
      <div className='counheadingscontdet' key={index}>
        <div className='countrycodedet'>
          <p>{post}</p>
        </div>
        <div className='countryvisidet'>
          <p>{countryCounts[post]}</p>
        </div>
        <div className='countrypercedet'>
          <p>{((countryCounts[post]/documentCount)*100).toFixed(2)}%</p>
        </div>
      </div>
    )

    /////////////////////////////////Device Count////////////////////////////////
    const deviceCounts = localData.reduce((acc, item) => {
      acc[item.deviceType] = (acc[item.deviceType] || 0) + 1;
      return acc;
    }, {});

    const sortedDevices = Object.keys(deviceCounts).sort((a, b) => deviceCounts[b] - deviceCounts[a]);

    // Take the first 10 categories just changed categories
    const topdevices = sortedDevices.slice(0, 10);

    const getdevicecard = topdevices.map((post, index) =>
      <div className='deviceheadingscontdet' key={index}>
        <div className='devicenamedet'>
          <p>{post}</p>
        </div>
        <div className='devicevisidet'>
          <p>{deviceCounts[post]}</p>
        </div>
        <div className='devicepercedet'>
          <p>{((deviceCounts[post]/documentCount)*100).toFixed(2)}%</p>
        </div>
      </div>
    )

    
      


      



    return (
        <>
        <div className='statsfilter'>
          {addPopup && (
            <div className="popupstats">
              <div className="popup-contentstats">
                  <p>{addPopupmessage}</p>
                  {addPopupmessage !== "searching" &&
                      <button className="yesbuttonstats" onClick={closeaddpop}>Done</button>
                  }
              </div>
            </div>
          )}
          <div className='statsfiltercont'>
            <form onSubmit={handleAddSubmit}>
                <div className="statsfiltercontbox">

                  <h2>Filter</h2>
                    
                              
                    <DatePicker 
                        selected={wstatsdayDetails.startDate} 
                        onChange={handleDateChange}
                        className="statsstartsearchdate"
                        name="libuserbkgrade"
                        placeholderText="Start Date"
                        dateFormat="yyyy-MM-dd" // Date format
                        showYearDropdown // Show year dropdown in the date picker
                        showMonthDropdown // Show month dropdown in the date picker
                        dropdownMode="select" // Dropdown mode for year and month dropdowns
                        autoComplete="off"
                        required
                    />

                    <DatePicker
                        selected={wstatsdayDetails.endDate} 
                        onChange={handlendDateChange} 
                        className="statsendsearchdate"
                        name="libuserbkgrade"
                        placeholderText="End Date"
                        dateFormat="yyyy-MM-dd" // Date format
                        showYearDropdown // Show year dropdown in the date picker
                        showMonthDropdown // Show month dropdown in the date picker
                        dropdownMode="select" // Dropdown mode for year and month dropdowns
                        autoComplete="off"
                        required
                    />
                    
                    <button className='statssearchbtn'>Search</button>
                                   
                </div>
            </form>
          </div>
        </div>
        <div className="webstatsmain" id="webstatsmain" ref={contentRef}>
            <div className='webstatscont'>
                <div className='dailytrendcont'>
                  <p>Website Usage Report</p>
                  <p>www.masiyejunior.org</p>
                  <p>{startDatetopic} to {currentDatetopic} </p>
                  <div className='dailytrendconttopic'>
                    <h3>Daily Visitor Trend</h3>
                  </div>
                  <div className={graphcss ? 'dailytrendgraph' : 'dailytrendgraphfalse'}>
                    {Object.keys(visitData).length > 0 ? (
                      <>
                        <Line options={options} data={chartData} ref={chartRef} />
                      </>
                    ) : (
                      <div>Loading data...</div>
                    )}
                  </div>
                </div>
                <div className='usageacont'>
                  <div className='usagetopic'>
                    <h3>Usage Stats</h3>
                  </div>
                  <div className='usagedetails'>
                    <p>Visitors: {documentCount}</p>

                    <p>Page Views: {grandTotal}</p>

                    <p>Pages/visitor: {(grandTotal/documentCount).toFixed(2)}</p>

                    <p>Total time on site: {hours} hours, {minutes} minutes, {remainingSeconds} seconds</p>

                    <p>Average time on site: {avehours} hours, {aveminutes} minutes, {averemainingSeconds} seconds</p>
                  </div>
                </div>
                <div className='contentovercont'>
                  <div className='overviewcont'>
                    <h3>Content Overview</h3>
                  </div>
                  <div className={graphcss ? 'overviewdetails' : 'overviewdetailsfalse'}>
                   <Bar options={optionbar} data={databar} ref={chartRef} />
                  </div>
                </div>
                <div className='countriescont'>
                  <div className='countriestopic'>
                    <h3>Visitors Country</h3>
                  </div>
                  <div className='countriestable'>
                    <div className='counheadingscont'>
                      <div className='countrycode'>
                        <p>Country Code</p>
                      </div>
                      <div className='countryvisi'>
                        <p>Visitors</p>
                      </div>
                      <div className='countryperce'>
                        <p>Visitor %</p>
                      </div>
                    </div>

                    {getcountriescard}
                  </div>
                </div>  
                <div className='devicestatscont'>
                  <div className='devicestatstopic'>
                    <h3>Device Stats</h3>
                  </div>
                  <div className='devicestatstable'>
                    <div className='deviceheadingscont'>
                      <div className='devicename'>
                        <p>Device</p>
                      </div>
                      <div className='devicevisi'>
                        <p>Visitors</p>
                      </div>
                      <div className='deviceperce'>
                        <p>Visitor %</p>
                      </div>
                    </div>

                    {getdevicecard}
                  </div>


                </div>


            </div>
        </div>

        <div className='downloadpdfstats'>
            <button onClick={generatePdf}>Download PDF</button>
        </div>
        </>
    );
    };

    
}
        
        
export default Webstats;